import React from "react";
import "./css/Footer.css";

function Footer() {
  return (
    <>
      <div className="container">
        <div className="contact_me text-center">
          <div className="title">Contact Me</div>
          <div className="media ">
            <a href="https://www.linkedin.com/in/swapnilsutar/">
              <i className="fa fa-linkedin-square" aria-hidden="true"></i>
            </a>
            <a href="https://github.com/swapnilsutar">
              <i class="fa fa-github" aria-hidden="true"></i>
            </a>
            <a href="#">
              <i class="fa fa-facebook-official" aria-hidden="true"></i>
            </a>
            <a href="#" target="_blank">
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </a>
          </div>
        </div>
        <br />
        <div className="footer ">Made with ❤ Swapnil Sutar 2023</div>
      </div>
    </>
  );
}

export default Footer;
